module.exports = __webpack_public_path__ + "img/152.6fae864a.jpg";